import { ReactElement } from "react";
import useUnderlineCardHover from "./contents/underlines/hooks/useUnderlineCardHover";
// import styles from "./style.shadow.css";
import cssMaxZIndex from "./util/cssMaxZIndex";
import useContentEditableAttachment from "./injection/useContentEditableAttachment";
import { useAllEditors, useAppDispatch } from "./store/hooks";
import ContentEditableRoot from "./ContentEditableRoot";
import { detach } from "./editorsSlice";
import styles from "./style/style.shadow.css";
import InlineCardController from "./contents/card/InlineCardController";

function PluginRoot(): ReactElement {
  const contenteditableAttachments = useContentEditableAttachment({
    enabled: true,
  });
  const hoverLogic = useUnderlineCardHover();
  const editors = useAllEditors();
  const dispatch = useAppDispatch();

  return (
    <>
      <style>{styles.toString()}</style>
      <div
        className="font-raleway pointer-events-none fixed top-0 left-0 w-screen h-screen"
        style={{ zIndex: cssMaxZIndex }}
      >
        <div className="pointer-events-auto">
          <InlineCardController
            textAreaStorage={contenteditableAttachments.current}
            hoverLogic={hoverLogic}
            contentEditableAttachments={contenteditableAttachments.current}
          />
        </div>
      </div>
      {contenteditableAttachments &&
        editors
          .filter((e) => e.type === "contenteditable")
          .map(({ id }) => {
            const attachment = contenteditableAttachments.current.get(id);
            if (attachment) {
              return (
                <ContentEditableRoot
                  key={id}
                  id={id}
                  attachment={attachment}
                  hoverLogic={hoverLogic}
                />
              );
            }
            console.warn(
              "Mismatch between redux state and mutable attachment storage. Detaching..."
            );
            dispatch(detach(id));
            return null;
          })
          .filter((x) => x)}
    </>
  );
}

export default PluginRoot;
